import { ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { KbMyOwnPartNumbersService } from 'src/app/services/feature/MyOwnPartNumbers/kb-my-own-part-numbers.service';
import { MyCompanyAccountService } from 'src/app/services/feature/myCompanyAccount/my-company-account.service';
import { RegisterService } from 'src/app/services/feature/register.service';
import { DeleteUserConfirmDialogComponent } from '../delete-user-confirm-dialog/delete-user-confirm-dialog.component';
import { UserRightsDialogComponent } from '../user-rights-dialog/user-rights-dialog.component';
import { GlobalMessageService, GlobalMessageType, TranslationService } from '@spartacus/core';
import { Subscription } from 'rxjs';

const MY_COMPANY = 'my-company'

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss'],
  standalone: false
})
export class EditUserComponent implements OnInit, OnDestroy {
  pageFieldData: any;
  accessRequestsWSList: any;
  countriesWSList: any;
  submitted: any;
  selectedRequestAccess: any = [];
  selectedIndustryRole: any;
  editUserInfo: any;
  userDetails$: any;
  showCustomerList: boolean = false;
  linkedCustomerList: any;
  stateList: any;
  selected: boolean[] = [false];
  searchInput;
  subscription = new Subscription();
  @HostListener('keydown.escape')
  @HostListener('document:click')
  onDocumentClick() {
    this.showCustomerList = false;
  }

  showSearchResults($event: Event) {
    $event.stopPropagation();
    this.showCustomerList = !this.showCustomerList;
  }
  private timeout?: ReturnType<typeof setTimeout> | null = null;// Store the timeout ID
  pageFieldData$ = this.registerService.getRegisterPageFields();
  editUserForm = new FormGroup({
    email: new FormControl(null, [Validators.email, Validators.required]),
    industry: new FormControl(null),
    industryRole: new FormControl(null),
    firstName: new FormControl(null, [Validators.required]),
    lastName: new FormControl(null, [Validators.required]),
    title: new FormControl(null),
    companyName: new FormControl(null, [Validators.required]),
    address1: new FormControl(null, [Validators.required]),
    address2: new FormControl(null),
    city: new FormControl(null, [Validators.required]),
    zip: new FormControl(null, [Validators.required]),
    country: new FormControl(null, [Validators.required]),
    state: new FormControl(null, [Validators.required]),
    houseNumber: new FormControl(null),
    phone: new FormControl(null),
    fax: new FormControl(null),
    website: new FormControl(null),
    linkedCustomerList: new FormControl(null),
    requestAccessFor: new FormControl(null),
  });

  constructor(
    private registerService: RegisterService,
    private cdf: ChangeDetectorRef,
    private route: ActivatedRoute,
    private myCompanyAccountService: MyCompanyAccountService,
    private dialog: MatDialog,
    private translationService: TranslationService,
    private globalMessageService: GlobalMessageService,
    private router: Router
  ) { }

  get f() {
    return this.editUserForm.controls;
  }

  ngOnInit() {
    this.subscription.add(
      this.registerService.getRegisterPageFields().subscribe((data) => {
        this.pageFieldData = data;
        this.getUserDetails();
        this.accessRequestsWSList = this.pageFieldData.accessRequestsWSList.filter((item) => item.code != 'DEALER_ADB');
        this.countriesWSList = this.pageFieldData.countriesWSList;
        if (this.pageFieldData && this.pageFieldData.titlesWSList && this.pageFieldData.titlesWSList.length > 0) {
          this.editUserForm.controls['title'].setValue(this.pageFieldData.titlesWSList[2].code);
        }
        this.cdf.detectChanges();
      })
    );
  }

  onSubmit() { }

  getUserDetails() {
    this.subscription.add(
      this.route.queryParams.subscribe((params) => {
        const user = params['user'];
        if (user) {
          this.userDetails$ = this.myCompanyAccountService.getUserDetails(user);

          this.subscription.add(
            this.userDetails$.subscribe((data: any) => {
              this.editUserInfo = data;
              this.editUserForm.controls['email'].setValue(data.editUserDetails.uid);
              this.editUserForm.controls['title'].setValue(data.editUserDetails.titleCode);
              this.editUserForm.controls['industryRole'].setValue(data.editUserDetails.industryRoleCodes[0]);
              this.editUserForm.controls['firstName'].setValue(data.editUserDetails.firstName);
              this.editUserForm.controls['lastName'].setValue(data.editUserDetails.lastName);
              this.editUserForm.controls['companyName'].setValue(data.editUserDetails.companyName);
              this.editUserForm.controls['city'].setValue(data.editUserDetails.companyCity);
              this.editUserForm.controls['zip'].setValue(data.editUserDetails.companyZip);
              this.editUserForm.controls['country'].setValue(data.editUserDetails.companyCountryCode);
              this.editUserForm.controls['phone'].setValue(data.editUserDetails.companyPhoneNumber);
              this.editUserForm.controls['fax'].setValue(data.editUserDetails.companyFaxNumber);
              this.editUserForm.controls['address1'].setValue(data.editUserDetails.companyStreet);
              this.editUserForm.controls['houseNumber'].setValue(data.editUserDetails.companyAddressTwo);
              this.editUserForm.controls['linkedCustomerList'].setValue(data.editUserDetails.defaultSoldTo);
              this.editUserForm.controls['website'].setValue(data.editUserDetails.companyWebsite);
              this.selectedRequestAccess = data.editUserDetails.accessRequestCodes;
              this.linkedCustomerList = JSON.parse(JSON.stringify([...new Set(data.linkedCustomerIdList)]));
              this.linkedCustomerList[0].selected = true;
              this.getStateList(data);
            })
          );
        }
      })
    );
  }

  selectRequestAccess(ev, val) {
    const index = this.editUserInfo.editUserDetails.accessRequestCodes.findIndex((x) => x === val.code);
    if (index > -1) {
      this.editUserInfo.editUserDetails.accessRequestCodes.splice(index, 1);
    } else {
      this.editUserInfo.editUserDetails.accessRequestCodes.push(val.code);
    }
  }

  selectIndustryRole(ev, val) {
    this.selectedIndustryRole = val;
    if (this.selectedIndustryRole.code === 'DISTRIBUTER') {
      this.accessRequestsWSList = this.pageFieldData.accessRequestsWSList;
    }
  }

  deleteUser() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = this.editUserForm.controls['email'].value;
    const dialogRef = this.dialog.open(DeleteUserConfirmDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((data) => {
      if (data.status === 'SUCCESS') {
        this.router.navigate([MY_COMPANY]);
        this.timeout = setTimeout(() => {
          let updatedKey = '';

          this.subscription.add(
            this.translationService.translate(data?.['message']).subscribe((key) => {
              if (key.includes('{0}')) {
                updatedKey = key.replace('{0}', data?.['errorValue1']);
              }
            })
          );
          this.globalMessageService.add(updatedKey, GlobalMessageType.MSG_TYPE_INFO);
        }, 2000);
      }
    });
  }

  setDisable() {
    this.subscription.add(
      this.myCompanyAccountService.setDisable(this.editUserForm.controls['email'].value).subscribe((data: any) => {
        if (data.status === 'SUCCESS') {
          this.router.navigate([MY_COMPANY]);
          this.timeout = setTimeout(() => {
            let updatedKey = '';

            this.subscription.add(
              this.translationService.translate(data?.['message']).subscribe((key) => {
                if (key.includes('{0}')) {
                  updatedKey = key.replace('{0}', data?.['errorValue1']);
                }
              })
            );
            this.globalMessageService.add(updatedKey, GlobalMessageType.MSG_TYPE_INFO);
          }, 2000);
        }
      })
    );
  }

  setEnable() {
    this.subscription.add(
      this.myCompanyAccountService.setEnable(this.editUserForm.controls['email'].value).subscribe((data: any) => {
        if (data.status === 'SUCCESS') {
          this.router.navigate([MY_COMPANY]);
          this.timeout = setTimeout(() => {
            let updatedKey = '';

            this.subscription.add(
              this.translationService.translate(data?.['message']).subscribe((key) => {
                if (key.includes('{0}')) {
                  updatedKey = key.replace('{0}', data?.['errorValue1']);
                }
              })
            );
            this.globalMessageService.add(updatedKey, GlobalMessageType.MSG_TYPE_INFO);
          }, 2000);
        }
      })
    );
  }

  setUserRight(customerDetails) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.panelClass = 'user-rights-popup';
    dialogConfig.data = this.editUserInfo.editUserDetails;

    dialogConfig.data['customer'] = this.editUserInfo.customer;

    if (this.editUserInfo.editUserDetails.accessRequestCodes.length > 0) {
      if (this.editUserInfo.editUserDetails.accessRequestCodes.indexOf("ORDER_ONLINE") > -1) {
        dialogConfig.data.onlineOrdering = true;
        dialogConfig.data.viewPriceAndATP = true;
      }
      if (this.editUserInfo.editUserDetails.accessRequestCodes.indexOf("CORE_REPORTS") > -1) {
        dialogConfig.data.coreRightsCodes.push('CORE_SUBMISSION', 'CORE_REPORTS');
      }
      if (this.editUserInfo.editUserDetails.accessRequestCodes.indexOf("SUBMIT_WARRANTY") > -1) {
        dialogConfig.data.warrantyRightsCodes.push('WARRANTY_SEARCH', 'WARRANTY_CLAIM')
      }
    }
    const dialogRef = this.dialog.open(UserRightsDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((data) => {
      if (data) {
        this.editUserInfo.editUserDetails.corePrice = data.coreCharge;
        this.editUserInfo.editUserDetails.listPrice = data.listPrice;
        this.editUserInfo.editUserDetails.netPrice = data.netPrice;
        this.editUserInfo.editUserDetails.coWorkerOrders = data.coWorkerInfo;
        this.editUserInfo.editUserDetails.viewPriceAndATP = data.priceAvail;
        this.editUserInfo.editUserDetails.priceDownloadAccess = data.downloadPriceFile;
        this.editUserInfo.editUserDetails.customerDocDownloadAccess = data.downloadCustomerDocs;
        this.editUserInfo.editUserDetails.updateMyPart = data.downLoadOwnPartNumber;
        this.editUserInfo.editUserDetails.warrantyRightsCodes = [];
        this.warrantyData(data);
        if (data.bookTechnicalTraining) {
          this.editUserInfo.editUserDetails.accessRequestCodes.push('TECHNICAL_TRAINING');
        } else {
          const index = this.editUserInfo.editUserDetails.accessRequestCodes.findIndex(
            (x) => x === 'TECHNICAL_TRAINING'
          );
          if (index > -1) {
            this.editUserInfo.editUserDetails.accessRequestCodes.splice(index, 1);
          }
        }
        this.cdf.detectChanges();
      }
    });
  }

  warrantyData(data) {
    if (data.warrantySearch) {
      this.editUserInfo.editUserDetails.warrantyRightsCodes.push('WARRANTY_SEARCH');
    }
    if (data.warrantyClaim) {
      this.editUserInfo.editUserDetails.warrantyRightsCodes.push('WARRANTY_CLAIM');
    }
    if (data.warrantyClaimValue) {
      this.editUserInfo.editUserDetails.warrantyRightsCodes.push('WARRANTY_CLAIM_VALUES');
    }
    this.editUserInfo.editUserDetails.coreRightsCodes = [];
    if (data.coreSubmission) {
      this.editUserInfo.editUserDetails.coreRightsCodes.push('CORE_SUBMISSION');
    }
    if (data.coreReports) {
      this.editUserInfo.editUserDetails.coreRightsCodes.push('CORE_REPORTS');
    }
    this.editUserInfo.editUserDetails.onlineOrdering = data.onlineOrdering;
    this.editUserInfo.editUserDetails.technicalTrainingAccess = data.bookTechnicalTraining;
    this.editUserInfo.editUserDetails.cutomerAdminFlag = data.customerAdmin;
    this.editUserInfo.editUserDetails.accessRequestCodes = [];
    if (data.coreReports || data.coreSubmission) {
      this.editUserInfo.editUserDetails.accessRequestCodes.push('CORE_REPORTS');
    }
    if (data.warrantySearch || data.warrantyClaim) {
      this.editUserInfo.editUserDetails.accessRequestCodes.push('SUBMIT_WARRANTY');
    }
    if (data.onlineOrdering || data.priceAvail || data.coreCharge || data.listPrice) {
      this.editUserInfo.editUserDetails.accessRequestCodes.push('ORDER_ONLINE');
    }
  }

  selectedCust(e) {
    if (this.linkedCustomerList.filter((item) => item.salesArea1 == e.salesArea1 && item.name == e.name).length == 0) {
      this.linkedCustomerList.push(e);
    }
  }

  removeLinkedAccount(data) {
    this.linkedCustomerList.forEach((element, i) => {
      if (element.salesArea1 == data.salesArea1 && element.name == data.name) {
        if (data.selected == true) {
          this.editUserForm.controls['linkedCustomerList'].setValue(
            this.linkedCustomerList[1].salesArea1 + this.linkedCustomerList[1].name
          );
        }
        this.linkedCustomerList.splice(i, 1);
      }
    });


  }

  selectLinkedCust(data, i) {
    this.linkedCustomerList.map((item) => (item.selected = false));
    this.linkedCustomerList[i].selected = true;
  }

  saveUser() {
    this.submitted = true;
    if (this.editUserForm.valid) {
      this.showCustomerList = false;
      const defaultUnit = this.linkedCustomerList.filter((item) => item.selected == true);
      const unidIds = [];
      this.linkedCustomerList.forEach((item) => {
        unidIds.push(item.uid);
      });
      const payload = {
        uid: this.editUserForm.controls['email'].value,
        titleCode: this.editUserForm.controls['title'].value,
        firstName: this.editUserForm.controls['firstName'].value,
        lastName: this.editUserForm.controls['lastName'].value,
        companyName: this.editUserForm.controls['companyName'].value,
        companyCity: this.editUserForm.controls['city'].value,
        companyZip: this.editUserForm.controls['zip'].value,
        companyCountryCode: this.editUserForm.controls['country'].value,
        companyPhoneNumber: this.editUserForm.controls['phone'].value,
        companyFaxNumber: this.editUserForm.controls['fax'].value,
        companyStreet: this.editUserForm.controls['address1'].value,
        companyWebsite: this.editUserForm.controls['website'].value,
        companyAddressTwo: this.editUserForm.controls['houseNumber'].value,
        industryRoleCodes: this.selectedIndustryRole
          ? [this.selectedIndustryRole.code]
          : this.editUserInfo.editUserDetails.industryRoleCodes,
        accessRequestCodes: this.editUserInfo.editUserDetails.accessRequestCodes,
        unitIds: unidIds,
        defaultSoldTo:
          defaultUnit && defaultUnit.length > 0 && defaultUnit[0].uid
            ? defaultUnit[0].uid
            : this.linkedCustomerList[0].uid,

        corePrice: this.editUserInfo.editUserDetails.corePrice || false,
        listPrice: this.editUserInfo.editUserDetails.listPrice || false,
        netPrice: this.editUserInfo.editUserDetails.netPrice || false,
        coWorkerOrders: this.editUserInfo.editUserDetails.coWorkerOrders || false,
        viewPriceAndATP: this.editUserInfo.editUserDetails.viewPriceAndATP || false,
        priceDownloadAccess: this.editUserInfo.editUserDetails.priceDownloadAccess || false,
        customerDocDownloadAccess: this.editUserInfo.editUserDetails.customerDocDownloadAccess || false,
        updateMyPart: this.editUserInfo.editUserDetails.updateMyPart || false,
        warrantyRightsCodes: this.editUserInfo.editUserDetails.warrantyRightsCodes || [],
        coreRightsCodes: this.editUserInfo.editUserDetails.coreRightsCodes || [],
        onlineOrdering: this.editUserInfo.editUserDetails.onlineOrdering || false,
        technicalTrainingAccess: this.editUserInfo.editUserDetails.technicalTrainingAccess || false,
        cutomerAdminFlag: this.editUserInfo.editUserDetails.cutomerAdminFlag || false,
      };

      this.subscription.add(
        this.myCompanyAccountService.updateUser(payload).subscribe((data) => {
          let updatedKey = '';

          this.subscription.add(
            this.translationService.translate(data?.['message']).subscribe((key) => {
              if (key.includes('{0}')) {
                updatedKey = key.replace('{0}', data?.['errorValue1']);
              }
            })
          );
          this.globalMessageService.add(updatedKey, GlobalMessageType.MSG_TYPE_INFO);
        })
      );
    }
  }

  getStateList(data?) {
    this.subscription.add(
      this.registerService.getRegions(this.editUserForm.controls['country'].value).subscribe((item: any) => {
        this.stateList = item?.regionsWSList;
        if (data) {
          this.editUserForm.controls['state'].setValue(data.editUserDetails.companyStateCode);
        }
        this.cdf.detectChanges();
      })
    );
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
}
